import React, { useEffect, useState } from "react";
import { Text, View } from "react-native";

import AppMessages from "../../../../config/AppMessages";
import ManaButton from "../../common/ManaButton";

import {
  navigate,
  getStorageItem,
  getStorageKey,
  setStorageItem,
} from "../../../../helpers/utils.js";
import cardStyles from "../cards/cardStyles";
import CloseIcon from "../../common/dialog/CloseIcon";

export default function SurveyCard({ controller }) {
  //const [showCard, setShowCard] = useState(true);
  // 2021.05.26: Disabled until we fix typeforms
  const [showCard, setShowCard] = useState(false);

  useEffect(() => {
    getStorageItem(getStorageKey(controller, "card:survey")).then((data) => {
      if (data && !data.show) {
        setShowCard(false);
      }
    });
  }, []);

  const hideCard = () => {
    setShowCard(false);
    setStorageItem(getStorageKey(controller, "card:survey"), {
      show: false,
    });
  };

  const onButtonPress = () => {
    navigate(controller, "rn:survey");
  };

  return !showCard ? null : (
    <View style={cardStyles.container}>
      <View
        style={[cardStyles.card, { minHeight: 76, justifyContent: "center" }]}
      >
        <CloseIcon onPress={() => hideCard()} style={cardStyles.closeButton} />
        <View style={[cardStyles.cardContent]}>
          <View style={{ flex: 1 }}>
            <Text style={cardStyles.title}>{AppMessages.SurveyCardTitle}</Text>
            <Text style={cardStyles.cardTextThin}>
              {AppMessages.SurveyCardText}
            </Text>
          </View>
          <ManaButton
            onPress={onButtonPress}
            style={[cardStyles.buttonSmall]}
            styleText={cardStyles.buttonSmallText}
            text="My Insights"
          />
        </View>
      </View>
    </View>
  );
}
